import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { compose } from "recompose";

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import DataTableContainer from './DataTableContainer';

const styles = theme => ({

});

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Toolbar disableGutters={true} className={classes.toolbar}>
                    <Typography variant="h5">Admin Dashboard</Typography>
                </Toolbar>
                {
                    this.props.user.isAdmin ?
                    <DataTableContainer /> : 'No Authentication'
                }
            </div>

        );
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;

    return {
        user,
    };
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles))(withCookies(App));


// WEBPACK FOOTER //
// ./src/components/AdminDashboard/Settings/App.js